import { ADMIN_PREFIX } from "@cti-workspace/helpers";
import { postApi } from "./api";

export default async function addCustomCredential(emailTemplate) {
	const url = `/${ADMIN_PREFIX}/addCustomCredentials`;
	return postApi(url, emailTemplate);
}
